import {
  SelectionSheet,
  Sheet,
  getTranslatedText,
  useIntl
} from '@nile/components/src';
import {
  AccountClient,
  GET_TECHS_BY_CRITERIA,
  GET_TECH_GROUP,
  useCachedQuery
} from '@nile/graphql/src';
import React, { useContext, useEffect, useState } from 'react';
import SchedulingContext from '../Contexts/SchedulingContext';
import { TextStyle } from '@superops/ui-design-system';
import { Tooltip } from 'react-clone-tippy';
import { SVGIcon } from '@superops/super-icons';

const TechnicianSelectionContainer = () => {
  const intl = useIntl();
  const schedulingContext = useContext(SchedulingContext);
  const [sections, setSections] = useState([]);
  const selectedTechniciansFromPersonalisation = schedulingContext?.selectedDispatcherTechnicians.map(
    (el) => ({
      ...el,
      label: el?.name,
      value: el?.name
    })
  );
  const [selectedTechs, setSelectedTechs] = useState(
    selectedTechniciansFromPersonalisation
  );

  const { loading: techDataLoading, data: techData } = useCachedQuery(
    GET_TECHS_BY_CRITERIA,
    {
      client: AccountClient,
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      }
    }
  );

  useEffect(() => {
    const technicianData = techData?.getTechnicianList?.userList || [];
    if (technicianData) {
      const sectionData = [
        {
          name: 'technicians',
          header: getTranslatedText(
            intl,
            'admin.Technicianrole.h2.allTechnicians'
          ),
          items: technicianData.map((user) => ({
            ...user,
            id: user?.userId,
            label: user?.name || user?.email,
            disable: !user?.calendarIntegrated
          }))
        }
      ];
      setSections(sectionData);
      const updatedUserList = [];
      selectedTechniciansFromPersonalisation.forEach((el) => {
        const userId = el?.userId;
        const isIntegrated = technicianData.find(
          (tech) => tech?.userId === userId && tech?.calendarIntegrated
        );
        if (isIntegrated) {
          updatedUserList.push(el);
        }
      });
      setSelectedTechs(updatedUserList);
    }
  }, [techData]);

  const updateTechnicianList = (updatedTechnicians) => {
    schedulingContext?.setSelectedDispatcherTechnicians(updatedTechnicians);
    schedulingContext?.saveDispatcherTechniciansToPersonalisation(
      updatedTechnicians
    );
  };

  const Template = (props) => {
    const notIntegrated = !props?.calendarIntegrated;
    return (
      <div className={`flex g5 actr ${notIntegrated ? 'opacity5' : ''}`}>
        <div>
          <TextStyle>{props?.name || props?.email}</TextStyle>
        </div>
        {notIntegrated && (
          <div>
            <Tooltip
              title={getTranslatedText(
                intl,
                'scheduling.technician.calendar.integration.pending.info'
              )}
              position="bottom"
              inertia
              trigger="mouseenter"
              animation="shift"
              animateFill={false}
              arrow
              distance={5}
            >
              <div className="pointer pt-5">
                <SVGIcon name="About" size="sm" />
              </div>
            </Tooltip>
          </div>
        )}
      </div>
    );
  };

  return (
    <SelectionSheet
      sections={sections}
      meta={{
        heading: getTranslatedText(intl, 'common.select.technicians'),
        selectedTitle: '  '
      }}
      // actions={props.actions}
      // data={allUsers}
      selectedItems={selectedTechs}
      toggleSheetActive={schedulingContext?.toggleTechnicianSheet}
      updateParent={updateTechnicianList}
      canReorder
      template={Template}
      key={JSON.stringify(selectedTechs)}
    />
  );
};

export default TechnicianSelectionContainer;
